import React, { useState, useEffect } from 'react';

const CORNERS = ['FHD', 'FHN', 'BHD', 'BHN', 'WEDD', 'WEDN', 'AVG'];

const METRICS = [
  { key: 'direct_cplh', label: 'Direct CPLH', type: 'rate' },
  { key: 'diluted_cplh', label: 'Diluted CPLH', type: 'rate' },
  { key: 'ib_cplh', label: 'IB CPLH', type: 'rate' },
  { key: 'ob_cplh', label: 'OB CPLH', type: 'rate' },
  { key: 'sep1', label: '', type: 'separator' },
  { key: 'pid_dept', label: 'PID', type: 'rate' },
  { key: 'fluid_total', label: 'Fluid Total', type: 'rate' },
  { key: 'fluid_direct', label: 'Fluid Direct', type: 'rate' },
  { key: 'fluid_offline', label: 'Fluid Offline', type: 'rate' },
  { key: 'eol', label: 'EOL', type: 'rate' },
  { key: 'aros_ib', label: 'AROS Inbound', type: 'rate' },
  { key: 'aros_ob', label: 'AROS Outbound', type: 'rate' },
  { key: 'ib_pr', label: 'IB PR', type: 'rate' },
  { key: 'pit', label: 'PIT', type: 'rate' },
  { key: 'sep2', label: '', type: 'separator' },
  { key: 'total_ib_cartons', label: 'Total IB Cartons', type: 'cartons' },
  { key: 'total_ob_cartons', label: 'Total OB Cartons', type: 'cartons' },
  { key: 'sorter_cartons', label: 'Sorter Cartons', type: 'cartons' },
  { key: 'aros_cartons', label: 'AROS Cartons', type: 'cartons' },
  { key: 'mr_cartons', label: 'MR Cartons', type: 'cartons' },
  { key: 'pr_cartons', label: 'PR Cartons', type: 'cartons' },
  { key: 'pr_pallets', label: 'PR Pallets', type: 'cartons' },
  { key: 'fluid_cartons', label: 'Fluid Cartons', type: 'cartons' },
  { key: 'fluid_direct_cartons', label: 'Fluid Direct', type: 'cartons' },
  { key: 'fluid_offline_cartons', label: 'Fluid Offline', type: 'cartons' },
  { key: 'eol_cartons', label: 'EOL Cartons', type: 'cartons' },
  { key: 'pit_cartons', label: 'PIT Cartons', type: 'cartons' },
  { key: 'sep3', label: '', type: 'separator' },
  { key: 'pid_unloader', label: 'PID Unloader', type: 'rate' },
  { key: 'pid_merge', label: 'PID Merge', type: 'rate' },
  { key: 'pid_reinject', label: 'PID Reinject', type: 'rate' },
  { key: 'pid_operator', label: 'PID Operator', type: 'rate' },
  { key: 'pid_dept_rate', label: 'PID Dept', type: 'rate' },
  { key: 'sep4', label: '', type: 'separator' },
  { key: 'direct_wallbuild', label: 'Direct Wallbuild', type: 'rate' },
  { key: 'jam_clear', label: 'Jam Clear', type: 'rate' },
  { key: 'fluid_ws', label: 'Fluid WS', type: 'rate' },
  { key: 'offline_wallbuild', label: 'Offline WallBuild', type: 'rate' },
  { key: 'fluid_total_rate', label: 'Fluid Total', type: 'rate' },
  { key: 'sep5', label: '', type: 'separator' },
  { key: 'pr_unload', label: 'PR Unload', type: 'rate' },
  { key: 'pallet_build', label: 'Pallet Build', type: 'rate' },
  { key: 'wrap_lantech', label: 'Wrap/Lantech', type: 'rate' },
  { key: 'pr_waterspider', label: 'Pallet Receiver', type: 'rate' },
  { key: 'ib_pr_dept', label: 'IB PR Dept', type: 'rate' },
  { key: 'sep6', label: '', type: 'separator' },
  { key: 'pit_unloader', label: 'IB PIT Unload', type: 'rate' },
  { key: 'pit_dept', label: 'PIT Dept', type: 'rate' },
  { key: 'sep7', label: '', type: 'separator' },
  { key: 'eol_avery', label: 'EOL Avery', type: 'rate' },
  { key: 'eol_divert', label: 'EOL Divert', type: 'rate' },
  { key: 'eol_sort', label: 'EOL Sort', type: 'rate' },
  { key: 'eol_waterspider', label: 'EOL Waterspider', type: 'rate' },
  { key: 'eol_reinject', label: 'EOL Reinject', type: 'rate' },
  { key: 'eol_dept', label: 'EOL Dept', type: 'rate' },
  { key: 'sep8', label: '', type: 'separator' },
  { key: 'aros_unloader', label: 'AROS Unloader', type: 'rate' },
  { key: 'aros_operator', label: 'AROS Operator', type: 'rate' },
  { key: 'aros_sticker', label: 'AROS Sticker', type: 'rate' },
  { key: 'aros_ib_dept', label: 'IB AROS Dept Total', type: 'rate' },
  { key: 'sep9', label: '', type: 'separator' },
  { key: 'aros_avery', label: 'AROS Avery', type: 'rate' },
  { key: 'aros_divert', label: 'AROS Divert', type: 'rate' },
  { key: 'aros_sort', label: 'AROS Sort', type: 'rate' },
  { key: 'aros_ws', label: 'AROS WS', type: 'rate' },
  { key: 'ob_aros_dept', label: 'OB AROS Dept', type: 'rate' },
];

function extractMetric(actual, key) {
  // If pre-computed value exists (from CSV upload), use it directly
  if (key in actual && actual[key] !== undefined && actual[key] !== null) {
    const val = parseFloat(actual[key]);
    if (!isNaN(val)) return val;
  }

  const c = actual.cartons || {};
  const ppr = actual.ppr_hours || {};
  const labor = actual.labor || [];

  const fcHrs = Object.values(ppr.fcSummary || {}).reduce((s, v) => s + v, 0);
  const ibHrs = Object.values(ppr.inbound || {}).reduce((s, v) => s + v, 0);
  const obHrs = Object.values(ppr.transferOut || {}).reduce((s, v) => s + v, 0);
  const ibCartons = c.inbound?.total || 0;
  const obCartons = c.outbound?.total || 0;

  const getLaborHrs = (name) => { const r = labor.find(l => l.process_path === name); return r?.total || 0; };
  const getLaborRate = (name, cartons) => { const hrs = getLaborHrs(name); return hrs > 0 ? cartons / hrs : 0; };
  const sumLaborHrs = (names) => names.reduce((s, n) => s + getLaborHrs(n), 0);
  const deptRate = (names, cartons) => { const hrs = sumLaborHrs(names); return hrs > 0 ? cartons / hrs : 0; };

  const pidCartons = c.pid?.total || 0;
  const arosCartons = c.aros?.total || 0;
  const prCartons = c.pr?.total || 0;
  const fluidDirect = c.fluidDirect?.total || 0;
  const fluidOffline = c.fluidOffline?.total || 0;
  const pitCartons = c.pit?.total || 0;
  const eolCartons = c.eol?.total ?? Math.max(0, pidCartons - fluidDirect);

  const map = {
    direct_cplh: (ibHrs + obHrs) > 0 ? (ibCartons + obCartons) / (ibHrs + obHrs) : 0,
    diluted_cplh: fcHrs > 0 ? (ibCartons + obCartons) / fcHrs : 0,
    ib_cplh: ibHrs > 0 ? ibCartons / ibHrs : 0,
    ob_cplh: obHrs > 0 ? obCartons / obHrs : 0,
    pid_dept: deptRate(['PID Unload', 'PID Divert', 'PID Reinject', 'PID Operator'], pidCartons),
    fluid_total: deptRate(['Sorter Wallbuild', 'Jam Clear', 'Fluid WS', 'Offline Wallbuild'], fluidDirect + fluidOffline),
    fluid_direct: deptRate(['Sorter Wallbuild'], fluidDirect),
    fluid_offline: deptRate(['Offline Wallbuild', 'Fluid WS'], fluidOffline),
    eol: deptRate(['EOL Avery', 'EOL Divert', 'EOL Sort', 'EOL Waterspider'], eolCartons),
    aros_ib: deptRate(['AROS Unload', 'AROS Operator', 'AROS CSX Label'], arosCartons),
    aros_ob: deptRate(['AROS Avery', 'AROS Divert', 'AROS Sort', 'AROS Waterspider'], arosCartons),
    ib_pr: deptRate(['PR Unload', 'Pallet Build', 'Wrap/Lantech', 'PR Waterspider', 'IB Pallet EPJ WS'], prCartons),
    pit: deptRate(['PIT Unloader', 'OB EPJ WaterSpider', 'Pallet Loader', 'OB EPJ Operator'], pitCartons),
    total_ib_cartons: ibCartons, total_ob_cartons: obCartons,
    sorter_cartons: pidCartons - fluidDirect, aros_cartons: arosCartons, mr_cartons: 0,
    pr_cartons: prCartons, pr_pallets: 0,
    fluid_cartons: fluidDirect + fluidOffline, fluid_direct_cartons: fluidDirect, fluid_offline_cartons: fluidOffline,
    eol_cartons: eolCartons, pit_cartons: pitCartons,
    pid_unloader: getLaborRate('PID Unload', pidCartons), pid_merge: getLaborRate('PID Divert', pidCartons),
    pid_reinject: getLaborRate('PID Reinject', pidCartons), pid_operator: getLaborRate('PID Operator', pidCartons),
    pid_dept_rate: deptRate(['PID Unload', 'PID Divert', 'PID Reinject', 'PID Operator'], pidCartons),
    direct_wallbuild: getLaborRate('Sorter Wallbuild', fluidDirect), jam_clear: getLaborRate('Jam Clear', pidCartons),
    fluid_ws: getLaborRate('Fluid WS', fluidOffline), offline_wallbuild: getLaborRate('Offline Wallbuild', fluidOffline),
    fluid_total_rate: deptRate(['Sorter Wallbuild', 'Jam Clear', 'Fluid WS', 'Offline Wallbuild'], fluidDirect + fluidOffline),
    pr_unload: getLaborRate('PR Unload', prCartons), pallet_build: getLaborRate('Pallet Build', prCartons),
    wrap_lantech: getLaborRate('Wrap/Lantech', prCartons), pr_waterspider: getLaborRate('PR Waterspider', prCartons),
    ib_pr_dept: deptRate(['PR Unload', 'Pallet Build', 'Wrap/Lantech', 'PR Waterspider', 'IB Pallet EPJ WS'], prCartons),
    pit_unloader: getLaborRate('PIT Unloader', pitCartons),
    pit_dept: deptRate(['PIT Unloader', 'OB EPJ WaterSpider', 'Pallet Loader', 'OB EPJ Operator'], pitCartons),
    eol_avery: getLaborRate('EOL Avery', eolCartons), eol_divert: getLaborRate('EOL Divert', eolCartons),
    eol_sort: getLaborRate('EOL Sort', eolCartons), eol_waterspider: getLaborRate('EOL Waterspider', eolCartons),
    eol_reinject: 0, eol_dept: deptRate(['EOL Avery', 'EOL Divert', 'EOL Sort', 'EOL Waterspider'], eolCartons),
    aros_unloader: getLaborRate('AROS Unload', arosCartons), aros_operator: getLaborRate('AROS Operator', arosCartons),
    aros_sticker: getLaborRate('AROS CSX Label', arosCartons),
    aros_ib_dept: deptRate(['AROS Unload', 'AROS Operator', 'AROS CSX Label'], arosCartons),
    aros_avery: getLaborRate('AROS Avery', arosCartons), aros_divert: getLaborRate('AROS Divert', arosCartons),
    aros_sort: getLaborRate('AROS Sort', arosCartons), aros_ws: getLaborRate('AROS Waterspider', arosCartons),
    ob_aros_dept: deptRate(['AROS Avery', 'AROS Divert', 'AROS Sort', 'AROS Waterspider'], arosCartons),
  };
  return map[key] || 0;
}

function getHeatColor(value, avg) {
  if (!avg || !value) return '#f5f5f5';
  const ratio = value / avg;
  if (ratio >= 1.05) return '#c8e6c9';
  if (ratio >= 1.0) return '#e8f5e9';
  if (ratio >= 0.95) return '#fff9c4';
  if (ratio >= 0.90) return '#ffcc80';
  return '#ef9a9a';
}

export default function Heapmat({ api, site }) {
  const [actuals, setActuals] = useState([]);
  const [filterType, setFilterType] = useState('relative');
  const [relativeFilter, setRelativeFilter] = useState('4weeks');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [weekLabel, setWeekLabel] = useState('');
  const [showHWM, setShowHWM] = useState(false);
  const [excludeWed, setExcludeWed] = useState(false);
  const [rates, setRates] = useState([]);

  useEffect(() => {
    fetch(`${api}/api/process-paths`).then(r => r.json()).then(data => { if (Array.isArray(data)) setRates(data); else setRates([]); }).catch(() => setRates([]));
  }, [api]);

  useEffect(() => {
    let from, to;
    if (filterType === 'relative') {
      to = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })();
      const d = new Date();
      if (relativeFilter === '4weeks') d.setDate(d.getDate() - 28);
      else if (relativeFilter === 'mtd') d.setDate(1);
      else if (relativeFilter === '12weeks') d.setDate(d.getDate() - 84);
      from = d.toISOString().split('T')[0];
    } else { from = fromDate; to = toDate; }

    if (from && to) {
      const dates = [];
      let dd = new Date(from + 'T12:00:00');
      const end = new Date(to + 'T12:00:00');
      while (dd <= end) { dates.push(dd.toISOString().split('T')[0]); dd.setDate(dd.getDate() + 1); }
      Promise.all(dates.flatMap(date => ['day','night'].map(shift =>
        fetch(`${api}/api/fclm/cache?site=${site}&date=${date}&shift_type=${shift}`)
          .then(r => r.json())
          .then(data => data?.labor ? { ...data, date, shift_type: shift, site } : null)
          .catch(() => null)
      ))).then(results => {
        const data = results.filter(Boolean);
        const withCorners = data.map(a => {
          const d = new Date(a.date + 'T12:00:00');
          const day = d.getDay();
          const isNight = a.shift_type === 'night';
          let corner;
          if (day === 3) corner = isNight ? 'WEDN' : 'WEDD';
          else if (day >= 0 && day <= 2) corner = isNight ? 'FHN' : 'FHD';
          else corner = isNight ? 'BHN' : 'BHD';
          return { ...a, corner };
        });
        const deduped = [];
        const seen = {};
        for (const item of withCorners) {
          const key = `${item.date}#${item.shift_type}`;
          if (!seen[key]) { seen[key] = item; deduped.push(item); }
          else if (item.cartons && !seen[key].cartons) { const idx = deduped.indexOf(seen[key]); deduped[idx] = item; seen[key] = item; }
        }
        setActuals(deduped);
      }).catch(() => setActuals([]));
      const wk = Math.ceil((new Date(from).getTime() - new Date(new Date().getFullYear(), 0, 1).getTime()) / 604800000);
      setWeekLabel(`Week ${wk}`);
    }
  }, [api, site, filterType, relativeFilter, fromDate, toDate]);

  // Filter actuals based on Wednesday toggle
  const filteredActuals = excludeWed ? actuals.filter(a => new Date(a.date + 'T12:00:00').getDay() !== 3) : actuals;

  // Compute averages per corner per metric
  const cornerData = {};
  for (const corner of CORNERS.filter(c => c !== 'AVG')) {
    const cornerActuals = filteredActuals.filter(a => a.corner === corner);
    cornerData[corner] = {};
    for (const m of METRICS) {
      if (m.type === 'separator') continue;
      const values = cornerActuals.map(a => extractMetric(a, m.key)).filter(v => v > 0);
      cornerData[corner][m.key] = values.length > 0 ? values.reduce((s, v) => s + v, 0) / values.length : 0;
    }
  }
  // Compute AVG across all corners
  cornerData['AVG'] = {};
  for (const m of METRICS) {
    if (m.type === 'separator') continue;
    const allVals = CORNERS.filter(c => c !== 'AVG').map(c => cornerData[c][m.key]).filter(v => v > 0);
    cornerData['AVG'][m.key] = allVals.length > 0 ? allVals.reduce((s, v) => s + v, 0) / allVals.length : 0;
  }

  // Compute HWM (best single shift) per metric from filtered data
  const hwmData = {};
  for (const m of METRICS) {
    if (m.type === 'separator') continue;
    const allVals = filteredActuals.map(a => extractMetric(a, m.key)).filter(v => v > 0);
    hwmData[m.key] = allVals.length > 0 ? Math.max(...allVals) : 0;
  }

  const cellStyle = { padding: '5px 10px', textAlign: 'center', fontSize: '0.8rem', fontWeight: 500, border: '1px solid #000' };

  // When Excl. Wed is on, also hide WEDD/WEDN columns
  const displayCorners = excludeWed ? CORNERS.filter(c => c !== 'WEDD' && c !== 'WEDN') : CORNERS;

  return (
    <div>
      <h2 className="section-title">Heapmat — {site}</h2>
      <div className="card">
        <div className="form-row">
          <div className="form-group">
            <label>Filter</label>
            <select value={filterType} onChange={e => setFilterType(e.target.value)}>
              <option value="relative">Relative</option>
              <option value="absolute">Absolute</option>
            </select>
          </div>
          {filterType === 'relative' ? (
            <div className="form-group">
              <label>Period</label>
              <select value={relativeFilter} onChange={e => setRelativeFilter(e.target.value)}>
                <option value="4weeks">Last 4 Weeks</option>
                <option value="mtd">MTD</option>
                <option value="12weeks">Last 12 Weeks</option>
              </select>
            </div>
          ) : (
            <>
              <div className="form-group"><label>From</label><input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} /></div>
              <div className="form-group"><label>To</label><input type="date" value={toDate} onChange={e => setToDate(e.target.value)} /></div>
            </>
          )}
        </div>
        <p style={{ fontSize: '0.8rem', color: '#666' }}>{actuals.length} shifts loaded | {weekLabel}</p>
      </div>

      <div className="card" style={{ overflowX: 'auto' }}>
        <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
          <button className={`btn ${showHWM ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setShowHWM(!showHWM)} style={{ fontSize: '0.8rem', padding: '4px 12px' }}>
            HWM {showHWM ? 'On' : 'Off'}
          </button>
          <button className={`btn ${excludeWed ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setExcludeWed(!excludeWed)} style={{ fontSize: '0.8rem', padding: '4px 12px' }}>
            Excl. Wed {excludeWed ? 'On' : 'Off'}
          </button>
        </div>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '0.8rem', border: '1px solid #000' }}>
          <thead>
            <tr>
              <th style={{ ...cellStyle, textAlign: 'left', background: '#232f3e', color: '#fff', position: 'sticky', left: 0, zIndex: 1 }}>Process Path</th>
              {showHWM && <th style={{ ...cellStyle, background: '#1565c0', color: '#fff' }}>HWM</th>}
              {displayCorners.map(c => <th key={c} style={{ ...cellStyle, background: '#232f3e', color: '#fff' }}>{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {METRICS.map(m => {
              if (m.type === 'separator') return <tr key={m.key}><td colSpan={displayCorners.length + 1 + (showHWM ? 1 : 0)} style={{ height: 8 }}></td></tr>;
              const avg = cornerData['AVG'][m.key];
              const hwm = hwmData[m.key] || 0;
              return (
                <tr key={m.key}>
                  <td style={{ ...cellStyle, textAlign: 'left', fontWeight: 600, position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>{m.label}</td>
                  {showHWM && <td style={{ ...cellStyle, background: '#e3f2fd', color: '#1565c0', fontWeight: 600 }}>{hwm ? (m.type === 'cartons' ? Math.round(hwm).toLocaleString() : hwm.toFixed(1)) : '—'}</td>}
                  {displayCorners.map(c => {
                    const val = cornerData[c]?.[m.key] || 0;
                    const bg = c === 'AVG' ? '#e3f2fd' : getHeatColor(val, avg);
                    return <td key={c} style={{ ...cellStyle, background: bg }}>{val ? (m.type === 'cartons' ? Math.round(val).toLocaleString() : val.toFixed(1)) : '—'}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Upload / Download */}
      <div className="card">
        <h3 className="section-title">Import / Export</h3>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <button className="btn btn-secondary" onClick={() => {
            const metrics = METRICS.filter(m => m.type !== 'separator');
            const header = ['Shift', ...metrics.map(m => m.label)].join(',');
            const rows = actuals.map(a => {
              const dateNum = Math.round((new Date(a.date).getTime() / 86400000) + 25569);
              const shiftId = `${dateNum}${a.shift_type === 'day' ? 'Day' : 'Night'}`;
              return [shiftId, ...metrics.map(m => {
                const val = extractMetric(a, m.key);
                return val ? (m.type === 'cartons' ? Math.round(val) : val.toFixed(2)) : '';
              })].join(',');
            });
            const csv = [header, ...rows].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `heapmat_${site}.csv`; a.click();
          }}>Download CSV</button>

          <button className="btn btn-secondary" onClick={() => {
            const metrics = METRICS.filter(m => m.type !== 'separator');
            const header = ['Shift', ...metrics.map(m => m.label)].join(',');
            const example = '46190Day,' + metrics.map(() => '').join(',');
            const csv = [header, example].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'heapmat_template.csv'; a.click();
          }}>Download Template</button>

          <form onSubmit={async (e) => {
            e.preventDefault();
            const fileInput = e.target.querySelector('input[type="file"]');
            if (!fileInput.files[0]) return;
            const text = await fileInput.files[0].text();
            const lines = text.trim().split('\n');
            if (lines.length < 2) return;
            const headers = lines[0].split(',');
            const metrics = METRICS.filter(m => m.type !== 'separator');
            const imported = [];
            for (let i = 1; i < lines.length; i++) {
              const cols = lines[i].split(',');
              const shiftId = cols[0] || '';
              const match = shiftId.match(/^(\d+)(Day|Night)$/i);
              if (!match) continue;
              const dateNum = parseInt(match[1]);
              const shiftType = match[2].toLowerCase() === 'night' ? 'night' : 'day';
              const jsDate = new Date((dateNum - 25569) * 86400000);
              const date = jsDate.toISOString().split('T')[0];
              const entry = { site, date, shift_type: shiftType };
              metrics.forEach((m, idx) => { entry[m.key] = parseFloat(cols[idx + 1]) || 0; });
              imported.push(entry);
            }
            if (imported.length > 0) {
              for (const entry of imported) {
                await fetch(`${api}/api/shift-actuals`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(entry) });
              }
              alert(`Imported ${imported.length} shifts`);
              window.location.reload();
            }
          }} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="file" accept=".csv" />
            <button type="submit" className="btn btn-primary">Upload CSV</button>
          </form>
        </div>
        <p style={{ fontSize: '0.75rem', color: '#666', marginTop: 8 }}>Shift identifier format: Excel date number + Day/Night (e.g. 46190Day, 46190Night)</p>
      </div>
    </div>
  );
}
